import { ReduxStore } from 'store/types';

import { IAuthDataProfile } from '../index';

function profile(state: ReduxStore): IAuthDataProfile {
  return state.auth.profile;
}

export default profile;
